import { BaseDto } from './base.dto';
import { EntityTypeDto } from './entityType.dto';
import { PrintTriggerType } from './printConfigurationCondition.dto';
export class PrintRequestQueueDto extends BaseDto{

    entity: EntityTypeDto;

    entityId: number;

    triggerType: PrintTriggerType;

    triggerTargetProperty?: string;
    
    
    metadata?: any;
}